function createMemorySyncFactory() {
  var states = /* @__PURE__ */ new Map();
  var nextId = 1;
  return {
    create(initial) {
      var id = nextId++;
      var state = {
        value: initial,
        onChange: null
      };
      states.set(id, state);
      var released = function released2() {
        if (!states.has(id)) throw new Error("OneNativeSyncState was released");
      };
      return {
        id,
        get: function get() {
          released();
          return state.value;
        },
        set: function set(next) {
          var _state_onChange;
          released();
          state.value = next;
          (_state_onChange = state.onChange) === null || _state_onChange === void 0 ? void 0 : _state_onChange.call(state, next);
        },
        setOnChange: function setOnChange(listener) {
          state.onChange = listener !== null && listener !== void 0 ? listener : null;
        },
        release: function release() {
          states.delete(id);
        }
      };
    }
  };
}
export {
  createMemorySyncFactory
};
//# sourceMappingURL=syncMemoryHost.js.map
